import type { IconData } from '@stacksjs/iconify-core'

export const pyramidShape: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path fill=\"#fff\" d=\"M43.387 38.436C38.109 40.859 28.437 45 24 45S9.891 40.859 4.613 38.436a3.8 3.8 0 0 1-1.776-5.265C9.1 21.485 17.627 9.55 21.677 4.08a2.874 2.874 0 0 1 4.645 0C30.374 9.55 38.9 21.486 45.163 33.17a3.8 3.8 0 0 1-1.776 5.265\"/><path fill=\"#8fbffa\" d=\"M24 45V2.9c.87 0 1.74.394 2.323 1.18C30.374 9.55 38.9 21.487 45.164 33.17a3.8 3.8 0 0 1-1.777 5.266C38.11 40.859 28.438 45 24 45\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M43.386 38.436C38.108 40.859 28.438 45 24 45S9.89 40.859 4.613 38.436a3.8 3.8 0 0 1-1.777-5.265C9.101 21.485 17.626 9.55 21.678 4.08a2.874 2.874 0 0 1 4.644 0c4.051 5.47 12.577 17.405 18.841 29.09a3.8 3.8 0 0 1-1.777 5.265M24 3v42\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default pyramidShape
